// Las 7 pantallas de la sección «la app por dentro» de la landing (lienzo Seccion_Mockups y Seccion_Mockups_Movil).
// Un solo módulo alimenta las pestañas de escritorio y los chips del carrusel móvil porque los dos tableros usan
// los mismos textos; así no pueden divergir (D-22). La pantalla 6 conserva «Tú puntúas…» y «Puntuado por ti» (D-29).
// P5-1 (D-22): el título de la pantalla 5 del lienzo prometía una plantilla propia, que no existe; los informes
// salen de las plantillas fijas de la app y el documento por secciones es el «Informe de seguimiento» (M5-1).

export interface PantallaApp {
    readonly numero: 1 | 2 | 3 | 4 | 5 | 6 | 7;
    readonly corto: string;
    readonly titulo: string;
    readonly frase: string;
    readonly fijate: string;
}

export const PANTALLAS_APP: readonly PantallaApp[] = [
    {
        numero: 1,
        corto: 'Mapa',
        titulo: 'Mapa de pacientes',
        frase: 'Abres la app y ves qué ha cambiado en cada paciente.',
        fijate: 'Cada tarjeta te avisa de lo pendiente: un consentimiento que falta, cambios propuestos en el plan o una sesión que se está transcribiendo.',
    },
    {
        numero: 2,
        corto: 'Tablero',
        titulo: 'Tablero del paciente',
        frase: 'Sesiones, documentos, plan y psicometría de un vistazo.',
        fijate: 'El plan de tratamiento te avisa cuando hay una propuesta pendiente de tu aprobación.',
    },
    {
        numero: 3,
        corto: 'Nota SOAP',
        titulo: 'Sesión y nota SOAP',
        frase: 'Al terminar la sesión, la nota ya está redactada.',
        fijate: 'La nota SOAP sale de la propia sesión y puedes editarla a mano; se guarda sola.',
    },
    {
        numero: 4,
        corto: 'Asistente',
        titulo: 'Asistente con citas',
        frase: 'Pregúntale lo que quieras y te responde citando la sesión.',
        fijate: 'La cita [S2] te lleva a la sesión de origen. Y la propuesta no se aplica hasta que pulsas Aprobar.',
    },
    {
        numero: 5,
        corto: 'Informes',
        titulo: 'Informe de seguimiento',
        frase: 'Un borrador por secciones, con cada dato citado.',
        fijate: 'Cada párrafo del informe lleva su cita y tú revisas sección a sección antes de exportar.',
    },
    {
        numero: 6,
        corto: 'Psicometría',
        titulo: 'Psicometría',
        frase: 'Tú puntúas; el asistente describe y compara.',
        // 17-REVIEW-C CR-02: «según el manual» prometía baremos que la app no tiene.
        fijate: '«Puntuado por ti»: el asistente describe las puntuaciones a partir de lo que trae el documento, pero no puntúa ni diagnostica.',
    },
    {
        numero: 7,
        corto: 'Cronología',
        titulo: 'Cronología y carpetas',
        frase: 'Todo el caso ordenado por fecha y por carpeta.',
        fijate: 'Si un documento no lleva fecha escrita, se señala para que la revises.',
    },
];

// El tablero arranca en el asistente (pantalla 4, base 1): es la pantalla más nueva y la que más enseña de la 2.0.
export const PANTALLA_INICIAL = 4;
